import { defaultAttributes } from "../helpers/roles/abr";
import { SettingsType } from "../types/app";

export const defaultSettings: SettingsType = {
  decimals: 1,
  primaryWeightFM: 2,
  secondaryWeightFM: 1,
  userRoleWeights: {
    TWve: defaultAttributes,
    MTWve: defaultAttributes,
    MTWun: defaultAttributes,
    MTWan: defaultAttributes,
    IVve: defaultAttributes,
    IVvo: defaultAttributes,
    IVru: defaultAttributes,
    BSVve: defaultAttributes,
    BSVvo: defaultAttributes,
    BSVru: defaultAttributes,
    KIVve: defaultAttributes,
    KIVvo: defaultAttributes,
    KIVru: defaultAttributes,
    LIun: defaultAttributes,
    LIan: defaultAttributes,
    AVve: defaultAttributes,
    AVun: defaultAttributes,
    AVan: defaultAttributes,
    FVve: defaultAttributes,
    FVun: defaultAttributes,
    FVan: defaultAttributes,
    KIAve: defaultAttributes,
    KFVun: defaultAttributes,
    KFVan: defaultAttributes,
    IAVve: defaultAttributes,
    IAVun: defaultAttributes,
    IAVan: defaultAttributes,
    ABRve: defaultAttributes,

    AMve: defaultAttributes,
    AMun: defaultAttributes,
    AMan: defaultAttributes,

    ASMun: defaultAttributes,
    ASMan: defaultAttributes,

    AZSun: defaultAttributes,
    AZSan: defaultAttributes,

    BEMve: defaultAttributes,
    BEMun: defaultAttributes,

    BBMun: defaultAttributes,

    CARun: defaultAttributes,

    DFLve: defaultAttributes,
    DFLun: defaultAttributes,

    DMve: defaultAttributes,
    DMun: defaultAttributes,

    ENGun: defaultAttributes,

    FLGun: defaultAttributes,
    FLGan: defaultAttributes,

    IASun: defaultAttributes,
    IASan: defaultAttributes,
    IFLun: defaultAttributes,
    IFLan: defaultAttributes,
    MEZun: defaultAttributes,
    MEZan: defaultAttributes,
    OMun: defaultAttributes,
    OMan: defaultAttributes,
    RMDan: defaultAttributes,
    REGun: defaultAttributes,
    SNSan: defaultAttributes,
    VOLun: defaultAttributes,
    VOLan: defaultAttributes,
    TSve: defaultAttributes,
    VESMun: defaultAttributes,
    VOSMun: defaultAttributes,
    VOSMan: defaultAttributes,
    ZMve: defaultAttributes,
    ZMun: defaultAttributes,
    ZMan: defaultAttributes,

    ZSMve: defaultAttributes,
    ZSMun: defaultAttributes,
    F9un: defaultAttributes,
    HASun: defaultAttributes,
    HASan: defaultAttributes,
    KNIan: defaultAttributes,
    KOSun: defaultAttributes,
    KOSan: defaultAttributes,
    PSTve: defaultAttributes,
    PSTun: defaultAttributes,
    PSTan: defaultAttributes,
    STSan: defaultAttributes,
    Tan: defaultAttributes,
    ZSun: defaultAttributes,
    ZSan: defaultAttributes,
  },
};
